

import { key } from './storeModule.js'
import moment from 'moment'

export default {
    install:(Vue, options) => {
        Object.defineProperty(Vue.prototype, '$camStream', {
            get(){                
                return {
                    _store:this.$store,
                    _storeModule:key,
                    _moment:moment,
                    startLive(device){
                        this._store.dispatch(`${this._storeModule}/startLive`, {device})
                    },
                    startPlayback(device, from, to){
                        this._store.dispatch(`${this._storeModule}/startPlayback`, {device, from, to})
                    },
                    startMomentPlayback(device, time, seconds){
                        time = this._moment(time)
                        let from = time.clone().subtract(seconds, 'seconds').format('YYYY-MM-DD HH:mm:ss')
                        let to = time.clone().add(seconds, 'seconds').format('YYYY-MM-DD HH:mm:ss')
                        this.startPlayback(device, from, to)
                    }
                }
            }
        })

}}